module.exports = __webpack_public_path__ + "static/media/logo_generalitat.70c266cb.png";